import React from 'react';

import { Container, SubsubsectionBody, SubsubsectionTitle } from './styles';

interface SubsubsectionProps {
	children?: React.ReactNode;
	title?: string;
	isImportant?: boolean;
}

const Subsubsection = ({ title, isImportant, children }: SubsubsectionProps) => {
	const body = () => {
		let innerContent = children;
		if (isImportant) {
			innerContent = <b>{innerContent}</b>;
		}
		return <SubsubsectionBody>{innerContent}</SubsubsectionBody>;
	};

	return (
		<Container>
			{title && <SubsubsectionTitle>{title}</SubsubsectionTitle>}
			{body()}
		</Container>
	);
};

export default Subsubsection;
